import React from "react";
import { Card, Tag, Typography, Space, Tooltip } from "antd";
import {
  GlobalOutlined,
  CopyOutlined,
  DeleteOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { formatToIST } from "../../../helper/CommonHelper";

const { Text, Link } = Typography;

function LandingPageCard({ data, onDelete }) {
    const navigate = useNavigate();

  return (
    <Card
      hoverable
      style={{
        borderRadius: 16,
      }}
      bodyStyle={{ padding: 16 }}
    >
      <Space direction="vertical" style={{ width: "100%" }}>
        
        {/* Header */}
        <Space style={{ justifyContent: "space-between", width: "100%" }}>
          <Space>
            <div
              style={{
                background: "#eee6ff",
                padding: 10,
                borderRadius: 12,
              }}
            >
              <GlobalOutlined
                style={{ fontSize: 18, color: "#7a5cff" }}
              />
            </div>

            <Text strong style={{ fontSize: 16 }}>
              {data?.name || "Untitled"}
            </Text>
          </Space>

          {/* <Tag color={data?.status ? "green" : "Active"} style={{ color:"black" }}>
            {data?.status ? "Capturing" : "Inactive"}
          </Tag> */}
        </Space>

        {/* Path */}
        {/* <Link style={{ color: "#7a5cff" }}>
          {data?.path || "/no-path"}
        </Link> */}

        {/* Redirect */}
        {/* <div
          style={{
            background: "#f6f1f1ed",
            padding: 12,
            borderRadius: 10,
          }}
        >
          <Text type="secondary">Redirects to:</Text>
          <br />
          <Text>{data?.redirect_url || "N/A"}</Text>
        </div> */}

        {/* Footer */}
        <Space
          style={{
            justifyContent: "space-between",
            width: "100%",
            marginTop: 8,
          }}
        >
          <Text type="secondary">
           {formatToIST(data?.created_at)}
          </Text>

          <Space>
            <Tooltip title="View">
            <EyeOutlined
              style={{ color: "#8c3add", cursor: "pointer",fontSize:"18px" }}
                onClick={() => navigate("/edit-landingpage/" + btoa(data.id))}
            />
          </Tooltip>
            {/* <Tooltip title="Copy URL">
              <CopyOutlined
                style={{ cursor: "pointer" }}
                onClick={() => {
                  navigator.clipboard.writeText(data?.redirect_url || "");
                }}
              />
            </Tooltip> */}

            <Tooltip title="Delete">
              <DeleteOutlined
                style={{ color: "red", cursor: "pointer",fontSize:"18px" }}
                onClick={() => onDelete(data.id)}
              />
            </Tooltip>
          </Space>
        </Space>
      </Space>
    </Card>
  );
}

export default LandingPageCard;